import { SupportedLocale } from '../context/LocaleContext';

export default function formatNumber(
    number: number,
    locale: SupportedLocale,
    options?: Intl.NumberFormatOptions
): string {
    return number.toLocaleString(locale, options);
}
